"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// ⚠ DO NOT change!!! Long imports are intentional here
var getSettingsValues_1 = require("@wix/tpa-settings/dist/src/contexts/SettingsContext/getSettingsValues");
var Controller_1 = require("../common/Controller");
var widgetSettings_1 = require("../../settings/widgetSettings");
var GroupsController_1 = require("./GroupsController");
var GroupsWidgetController = /** @class */ (function (_super) {
    tslib_1.__extends(GroupsWidgetController, _super);
    function GroupsWidgetController(controllerConfig, experiments) {
        if (experiments === void 0) { experiments = {}; }
        var _this = _super.call(this, controllerConfig, experiments) || this;
        _this.controllers.push(new GroupsController_1.default(controllerConfig));
        return _this;
    }
    GroupsWidgetController.prototype.bootstrapSettings = function (config) {
        var settings = _super.prototype.bootstrapSettings.call(this, this.config);
        // TODO: refactor for more modularity [TD]
        var display = getSettingsValues_1.getSettingsValues(config.publicData.COMPONENT || {}, widgetSettings_1.widgetDisplaySettings);
        var layout = getSettingsValues_1.getSettingsValues(config.publicData.COMPONENT || {}, widgetSettings_1.widgetLayoutSettings);
        Object.assign(settings.display, display);
        Object.assign(settings.layout, layout);
        return settings;
    };
    return GroupsWidgetController;
}(Controller_1.Controller));
function createGroupsWidgetController(controllerConfig, experiments) {
    if (experiments === void 0) { experiments = {}; }
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            return [2 /*return*/, new GroupsWidgetController(controllerConfig, experiments)];
        });
    });
}
exports.createGroupsWidgetController = createGroupsWidgetController;
//# sourceMappingURL=GroupsWidgetController.js.map